// extracted by mini-css-extract-plugin
export var footer = "_ly-5";
export var fulfillmentInput = "_ly-0";
export var shipDateInput = "_ly-1";
export var shipmentModal = "_ly-2";
export var shipmentModalContent = "_ly-3";
export var tableContainer = "_ly-4";